/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overviewliveopenroom3Inputs */

const en_overviewliveopenroom3 = /** @type {(inputs: Overviewliveopenroom3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the Live Room`)
};

const de_overviewliveopenroom3 = /** @type {(inputs: Overviewliveopenroom3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Live Room`)
};

/**
* | output |
* | --- |
* | "Open the Live Room" |
*
* @param {Overviewliveopenroom3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const overviewliveopenroom3 = /** @type {((inputs?: Overviewliveopenroom3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overviewliveopenroom3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_overviewliveopenroom3(inputs)
	return de_overviewliveopenroom3(inputs)
});
export { overviewliveopenroom3 as "overviewLiveOpenRoom" }